<template>
    <Teleport to="body">
      <Transition name="modal">
        <section class="modal">
          <div class="modal-content">
            <div class="modal-top">
             
              <span @click="handleClose" role="button"
                class="size-7 bg-white absolute top-6 right-7 flex items-center justify-center rounded-lg">
                <i class="pi pi-times" />
              </span>
            </div>
           <CalcPayroll link-id="calculator" forModal/>
          </div>
        </section>
      </Transition>
    </Teleport>
 
  </template>
  
  <script setup>
  import { ref, computed } from "vue";
  import EaziBtn from "./ui/EaziBtn.vue";
  import { useToast } from "vue-toastification";
  import { useDataStore } from "@/stores/data";
import PayrollCalculator from "../business/PayrollCalculator.vue";
import CalcPayroll from "./CalcPayroll.vue"
  const store = useDataStore();
  
  const toast = useToast();
  const { mutate } = store;
  
  const emit = defineEmits(["close"]);
  
  const handleClose = () => {
    emit("close");
  };
  
  const showDoneModal = ref(false);
  
  const handleCloseDoneModal = () => {
    showDoneModal.value = !showDoneModal.value;
    handleClose();
  };
  
  const surveyQuestions = ref([
    {
      id: "1",
      text: "What is the nature of your business?",
      options: [
        "Industry One",
        "Industry Two",
        "Industry Three",
        "Industry Four",
        "Industry Five",
        "Industry Six",
        "Industry Seven",
        "Industry Eight",
      ],
      selectedOption: "",
      showTextArea: false,
      otherTxt: "",
    },
    {
      id: "2",
      text: "Is Your Business Registered?",
      options: ["No", "Yes"],
      selectedOption: null,
      showTextArea: false,
      otherTxt: "",
    },
    {
      id: "3",
      text: "What Year Did Your Business Commence Operation?",
      options: [
        "Less than 1 Year",
        "1 - 2 years",
        "3 - 5 years",
        "6 - 10 years",
        "11 - 15 years",
        "Above 15 years",
      ],
      selectedOption: null,
      showTextArea: false,
      otherTxt: "",
    },
    {
      id: "4",
      text: "What do you find difficult to do during your monthly payroll? ",
      options: [
        "Accuracy in Calculations",
        "Timely Deduction & Remittance",
        "Generating Compliance Reports",
        "Others",
      ],
      selectedOption: [],
      showTextArea: false,
      otherTxt: "",
    },
    {
      id: "5",
      text:
        "Eazipay sends your official government receipt for PAYE payments. Do you want to try it?",
      options: ["No", "Yes"],
      selectedOption: null,
      showTextArea: false,
      otherTxt: "",
    },
    {
      id: "6",
      text: "What is Your Business Structure?",
      options: [
        "Sole Proprietorship",
        "Partnership",
        "Limited Liability Company",
        "Non-Governmental Organisation",
        "Others",
      ],
      selectedOption: null,
      showTextArea: false,
      otherTxt: "",
    },
    {
      id: "7",
      text: "How Many Employees Do You Have?",
      options: ["1 -5", "6 - 20", "21 - 50", "51 - 100", "Above 100"],
      selectedOption: null,
      showTextArea: false,
      otherTxt: "",
    },
  ]);
  
  const currentStep = ref(0);
  const currentQuestion = computed(() => surveyQuestions.value[currentStep.value]);
  
  const nextStep = () => {
    if (currentStep.value < surveyQuestions.value.length - 1) {
      currentStep.value++;
    }
  };
  
  // Move to previous step
  const prevStep = () => {
    if (currentStep.value > 0) {
      currentStep.value--;
    }
  };
  
  const toggleOption = (option) => {
    // Ensure selectedOptions is always an array
    if (!currentQuestion.value.selectedOptions) {
      currentQuestion.value.selectedOptions = [];
    }
  
    const selectedOptions = currentQuestion.value.selectedOptions;
  
    if (selectedOptions.includes(option)) {
      // Remove the option if already selected
      currentQuestion.value.selectedOptions = selectedOptions.filter((o) => o !== option);
    } else {
      // Add the option if not selected
      currentQuestion.value.selectedOptions.push(option);
    }
  
    // Show textarea only if "Others" is selected
    currentQuestion.value.showTextarea = currentQuestion.value.selectedOptions.includes(
      "Others"
    );
  };
  
  const handleSelectOption = (option) => {
    currentQuestion.value.selectedOption = option;
    currentQuestion.value.showTextarea = option === "Others";
  
    if (currentStep.value === 1) {
      if (option === "No") {
        handleClose();
      } else if (option === "Yes") {
        setTimeout(() => nextStep(), 500);
      }
      return;
    }
    if (currentStep.value === 5) {
      currentQuestion.value.showTextarea = false;
    } else {
      // For other steps, toggle the textarea when 'Others' is selected
      currentQuestion.value.showTextarea = option === "Others";
    }
    if (currentStep.value !== 3) {
      setTimeout(() => nextStep(), 500);
    }
  };
  
  // const transformToBoolean = (value) => {
  //   if (value === "Yes") return true;
  //   if (value === "No") return false;
  //   return value;
  // };
  
  const isRegistered = computed(() => surveyQuestions.value[1].selectedOption === "Yes");
  const isInterestedInReceipt = computed(
    () => surveyQuestions.value[4].selectedOption === "Yes"
  );
  
  const handleSubmit = async () => {
    const payload = {
      businessNature: surveyQuestions.value[0].selectedOption,
      businessStructure: surveyQuestions.value[5].selectedOption,
      isRegistered: isRegistered.value,
      commencementYear: surveyQuestions.value[2].selectedOption,
      employeeCount: surveyQuestions.value[6].selectedOption,
      interestedInEazipayReceipt: isInterestedInReceipt.value,
      payrollDifficulties: {
        options: surveyQuestions.value[3].selectedOption,
        others: surveyQuestions.value[3].otherTxt,
      },
    };
  
    try {
      let res = await mutate({
        endpoint: "SaveSurvey",
        data: { input: payload },
        service: "PAYROLL",
      });
      if (res.success) {
        showDoneModal.value = !showDoneModal.value;
      } else {
        toast.error("something went wrong!");
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  </script>
  
  <style lang="scss" scoped>
  .modal {
    @apply fixed inset-0 grid place-items-center p-4 w-full h-full;
    background: rgba(17, 69, 59, 0.7);
    z-index: 10;
  }
  
  .second-modal {
    @apply fixed inset-0 grid place-items-center p-4 w-full h-full;
    background: rgba(17, 69, 59, 0.7);
    z-index: 30;
  
    .content {
      @apply w-[310px] md:w-[343px] h-[328px] rounded-[40px] bg-white;
    }
  }
  
  .modal-content {
  @apply bg-white h-[95%] overflow-y-auto rounded-[40px];
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.modal-content::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}
  
  .hrozontal-line {
    @apply w-full md:w-[552px] h-px mx-auto block mt-4;
    background: rgba(243, 243, 243, 1);
  }
  
  .survey-content {
    @apply w-full md:w-[552px] mx-auto mt-6 px-4 md:px-0;
  }
  
  .pills-btn {
    @apply min-w-16 py-2 px-4 text-14 flex items-center justify-center cursor-pointer gap-3;
    border: 1px solid rgba(233, 233, 233, 1);
  }
  
  input[type="radio"]:checked~p {
    border: 1px solid rgba(217, 235, 205, 1);
    background: rgba(217, 235, 205, 1);
    box-shadow: 0px 6px 12px 0px rgba(170, 170, 170, 0.11);
  }
  
  input[type="checkbox"]:checked~p {
    border: 1px solid rgba(217, 235, 205, 1);
    background: rgba(217, 235, 205, 1);
    box-shadow: 0px 6px 12px 0px rgba(170, 170, 170, 0.11);
  }
  
  .text-area {
    @apply w-full outline-none border-none h-[88px] rounded-xl px-5 py-2;
    resize: none;
    background: rgba(248, 248, 248, 1);
  }
  
  button {
    outline: none !important;
    border: none !important;
    // all: unset;
  }
  
  .btn {
    @apply w-[85px] h-10 rounded-3xl text-white;
    // background: rgba(17, 69, 59, 1);
  }
  
  .modal-enter-active,
  .modal-leave-active {
    transition: 0.25s ease;
  }
  
  .modal-enter-from {
    transform: scale(1.04);
    opacity: 0;
  }
  
  .modal-leave-to {
    opacity: 0;
  }
  </style>
  